document.addEventListener("turbo:load", () => {
  const chartEl = document.querySelector("#sales-purchases-chart");
  if (chartEl && window.ApexCharts) {
    fetch("/dashboard/sales_vs_purchases_data")
      .then(response => response.json())
      .then(data => {
        const categories = data.map(item => item.date);
        const salesData = data.map(item => item.sales);
        const purchaseData = data.map(item => item.purchases);

        const options = {
          series: [
            { name: "Sales", data: salesData },
            { name: "Purchases", data: purchaseData }
          ],
          chart: { type: "area", height: 300, toolbar: { show: false } },
          colors: ["#0d6efd", "#198754"],
          dataLabels: { enabled: false },
          stroke: { curve: "smooth" },
          xaxis: { type: "datetime", categories: categories },
          tooltip: { x: { format: "dd MMM yyyy" } }
        };

        new ApexCharts(chartEl, options).render();
      })
      .catch(error => console.error("Error loading sales vs purchases data:", error));
  }
});
